<template>
  <div class="content">
    <div>
      <h2 class="page-title mb-4">管理</h2>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">
        アカウント一覧
        <span class="f-size-16 red">
          <br v-if="isMobile" />
          ※ロジコ社員（管理者）アカウントは表示されません
        </span>
      </h4>
      <section id="admin-company-list">
        <div class="section-child">
          <div class="mb-3 mt-md-4 px-3">
            <div class="ml-md-3 search-wrapper">
              <div class="mb-md-4">
                <label
                  class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
                >
                  お名前
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-2"
                  v-model="search.acc.name"
                  @change="setAccount()"
                />
                <label
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0 mt-2 mt-md-0"
                >
                  メールアドレス
                </label>
                <input
                  type="email"
                  class="d-inline form-control col-md-2"
                  v-model="search.acc.mail"
                  @change="setAccount()"
                />
                <label
                  class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0 mt-2 mt-md-0"
                >
                  会社名
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-2"
                  v-model="search.acc.company"
                  @change="setAccount()"
                />
              </div>

              <div v-if="isEnableDatepicker" class="mb-md-4">
                <label
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 my-0 mt-2 mt-md-0"
                >
                  ステータス
                </label>
                <select
                  class="d-inline form-control col-md-2"
                  @change="setAccount()"
                  v-model="search.acc.status"
                >
                  <option value="" key="" selected>選択なし</option>
                  <option
                    v-for="(item, key) in accountStatus"
                    :value="key"
                    :key="key"
                  >
                    {{ item }}
                  </option>
                </select>
                <label
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0 mt-2 mt-md-0"
                >
                  申請日
                </label>
                <div :class="['text-left', { 'd-inline': !isMobile }]">
                  <input
                    type="date"
                    :class="[
                      'form-control col-md-2',
                      { 'd-inline': !isMobile },
                    ]"
                    v-model="search.acc.from"
                    @change="setAccount()"
                  />
                  <span class="mx-4 mx-md-2">〜</span>
                  <input
                    type="date"
                    :class="[
                      'form-control col-md-2',
                      { 'd-inline': !isMobile },
                    ]"
                    v-model="search.acc.to"
                    @change="setAccount()"
                  />
                </div>
              </div>
              <div v-else class="row mt-4">
                <label class="col-lg-1 text-left ml-3 px-0 pt-2">
                  ステータス
                </label>
                <select
                  class="form-control col-md-2"
                  @change="setAccount()"
                  v-model="search.acc.status"
                >
                  <option value="" key="" selected>選択なし</option>
                  <option
                    v-for="(item, key) in accountStatus"
                    :value="key"
                    :key="key"
                  >
                    {{ item }}
                  </option>
                </select>
                <label
                  class="d-md-inline col-lg-1 text-left px-0 pl-md-4 my-0 pt-2 mt-md-0"
                >
                  申請日
                </label>
                <Datepicker
                  :clear-button="true"
                  :format="datePickerFormat"
                  :language="ja"
                  class="col-md-2 p-0"
                  v-model="search.acc.from"
                  @input="
                    search.acc.from = dateObjToStr(search.acc.from)
                    setAccount()
                  "
                />
                <span class="mx-4 mx-md-2">〜</span>
                <Datepicker
                  :clear-button="true"
                  :format="datePickerFormat"
                  :language="ja"
                  class="col-md-2 p-0"
                  v-model="search.acc.to"
                  @input="
                    search.acc.to = dateObjToStr(search.acc.to)
                    setAccount()
                  "
                />
              </div>

              <div class="mb-md-4">
                <label
                  class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
                >
                  ユーザID
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-2"
                  v-model="search.acc.user_id"
                  @change="setAccount()"
                />
                <label
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0 mt-2 mt-md-0"
                >
                  グループ
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-2"
                  v-model="search.acc.group_name"
                  @change="setAccount()"
                />
              </div>
            </div>
          </div>

          <div class="row m-0">
            <p class="f-size-14 sp-fs-12 col-6 pl-4 pt-md-3 red bold">
              検索結果は最大25件まで表示されます。
            </p>
            <div class="text-right col-6 mb-1">
              <b-button
                v-if="this.isSetGroup"
                class="btn btn-info sp-fs-14 mb-2"
                @click="showGroupDialog = true"
              >
                グループ管理
              </b-button>
              <b-button
                v-if="this.isSetGroup"
                class="btn btn-success sp-fs-14 mb-2"
                @click="newAccount"
              >
                新規作成
              </b-button>
            </div>
          </div>
          <div v-if="async.accounts" class="spinner">
            <md-progress-spinner md-mode="indeterminate" />
          </div>
          <div v-else>
            <md-table
              v-if="accounts.length"
              v-model="accounts"
              md-sort="date"
              md-sort-order="desc"
              md-card
              class="mb-4 p-2 bg-gray h-400"
              md-fixed-header
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  md-label="申請日"
                  md-sort-by="date"
                  :class="{ 'bg-blue white': isMobile }"
                >
                  <span v-if="!isMobile">{{ dateFormat(item.date) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">申請日</p>
                    <p class="col-9 p-0">{{ dateFormat(item.date) }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="会社名" md-sort-by="company">
                  <span v-if="!isMobile">
                    {{ omitText(item.company, 20) }}
                    <br />
                    （TEL:&nbsp;{{ item.TORIHIKI_SAKI_TEL }}）
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">会社名</p>
                    <p class="col-9 p-0">
                      {{ item.company }}
                      <br />
                      （TEL:&nbsp;{{ item.TORIHIKI_SAKI_TEL }}）
                    </p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="ID/グループ" md-sort-by="name">
                  <span v-if="!isMobile">
                    {{ omitText(item.USER_ID, 10) }}
                    <br />
                    {{ omitText(item.GROUP_NAME, 10) }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">ID/グループ</p>
                    <p class="col-9 p-0">
                      {{ item.USER_ID }}
                      <br />
                      {{ item.GROUP_NAME }}
                    </p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="お名前" md-sort-by="name">
                  <span v-if="!isMobile">{{ omitText(item.name, 10) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">お名前</p>
                    <p class="col-9 p-0">{{ item.name }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="ステータス" md-sort-by="STATUS">
                  <span
                    v-if="!isMobile"
                    :class="[{ red: isCheckRestrict(item.STATUS) }]"
                  >
                    {{ accountStatus[item.STATUS] }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">ステータス</p>
                    <p
                      :class="[
                        'col-9 p-0',
                        { red: isCheckRestrict(item.STATUS) },
                      ]"
                    >
                      {{ accountStatus[item.STATUS] }}
                    </p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="" class="p-0">
                  <b-button
                    class="btn-secondary list-btn sp-fs-14"
                    @click="
                      delset(item)
                      isDeleteConfirm = true
                    "
                  >
                    削除
                  </b-button>
                  <b-button
                    class="btn-success list-btn sp-fs-14"
                    @click="editAccount(item)"
                  >
                    編集
                  </b-button>
                  <b-button
                    v-if="isCheckActivated(item.STATUS)"
                    class="btn-info list-btn mt-md-1 mt-lg-0 sp-fs-14"
                    @click="dairiLogin(item)"
                  >
                    代理ログイン
                  </b-button>
                  <b-button
                    v-if="isCheckRestrict(item.STATUS)"
                    class="btn-info list-btn mt-md-1 mt-lg-0 sp-fs-14"
                    @click="sendMail(item)"
                  >
                    再アクティベート
                  </b-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center my-5 bold">
              該当するアカウントはありません。
            </div>
          </div>
        </div>
      </section>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">
        お知らせ&emsp;現状の輸送状況設定
      </h4>
      <section id="admin-info-title">
        <div class="section-child">
          <div class="ml-lg-4 py-2">
            <label class="pt-2 col-md-1 d-inline">現状の輸送状況</label>
            <input
              type="text"
              class="form-control col-11 col-md-9 d-inline ml-3 ml-md-0"
              v-model="infomations.title"
            />
            <b-button
              v-if="!isMobile"
              class="btn-success list-btn col-md-1 d-inline mt-n1 sp-fs-14"
              @click="saveInfoTitle()"
            >
              登録
            </b-button>
            <div v-else class="text-right">
              <b-button
                class="btn-success list-btn col-3 d-inline mt-2 mr-3 sp-fs-14"
                @click="isSaved = true"
              >
                登録
              </b-button>
            </div>
          </div>
        </div>
      </section>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-5">お知らせ一覧</h4>
      <section id="admin-info-list">
        <div class="section-child">
          <div class="mb-3 mt-md-4 px-3">
            <div class="ml-md-3 search-wrapper">
              <div class="mb-md-4">
                <label
                  class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
                >
                  タイトル
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-2"
                  v-model="search.info.title"
                  @change="setInfo()"
                />
                <label
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0"
                >
                  メッセージ
                </label>
                <input
                  type="email"
                  class="d-inline form-control col-md-2"
                  v-model="search.info.message"
                  @change="setInfo()"
                />
                <label
                  v-if="isEnableDatepicker"
                  class="d-md-inline col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0"
                >
                  登録日
                </label>
                <div
                  v-if="isEnableDatepicker"
                  :class="['text-left', { 'd-inline': !isMobile }]"
                >
                  <input
                    type="date"
                    :class="[
                      'form-control col-md-2',
                      { 'd-inline': !isMobile },
                    ]"
                    v-model="search.info.from"
                    @change="setInfo()"
                  />
                  <span class="mx-4 mx-md-2">〜</span>
                  <input
                    type="date"
                    :class="[
                      'form-control col-md-2',
                      { 'd-inline': !isMobile },
                    ]"
                    v-model="search.info.to"
                    @change="setInfo()"
                  />
                </div>
              </div>
              <div v-if="!isEnableDatepicker" class="row mt-4">
                <label
                  class="d-md-inline col-lg-1 text-left px-0 pl-md-4 my-0 pt-2 mt-md-0"
                >
                  登録日
                </label>
                <Datepicker
                  :clear-button="true"
                  :format="datePickerFormat"
                  :language="ja"
                  class="col-md-2 p-0"
                  v-model="search.info.from"
                  @input="
                    search.info.from = dateObjToStr(search.info.from)
                    setInfo()
                  "
                />
                <span class="mx-4 mx-md-2">〜</span>
                <Datepicker
                  :clear-button="true"
                  :format="datePickerFormat"
                  :language="ja"
                  class="col-md-2 p-0"
                  v-model="search.info.to"
                  @input="
                    search.info.to = dateObjToStr(search.info.to)
                    setInfo()
                  "
                />
              </div>
            </div>
          </div>
          <div class="row m-0">
            <p class="f-size-14 sp-fs-12 col-6 pl-4 pt-md-3 red bold">
              検索結果は最大25件まで表示されます。
            </p>
            <div class="text-right col-6 mb-1">
              <b-button
                class="btn btn-success sp-fs-14"
                @click="
                  newInfo()
                  showEditInfoDialog = true
                "
              >
                新規作成
              </b-button>
            </div>
          </div>

          <div v-if="async.info" class="spinner">
            <md-progress-spinner md-mode="indeterminate" />
          </div>
          <div v-else>
            <md-table
              v-if="infomations.body.length"
              v-model="infomations.body"
              md-sort="KOSHIN_NICHIJI"
              md-sort-order="desc"
              md-card
              class="mb-4 p-2 bg-gray h-400"
              md-fixed-header
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  md-label="登録日"
                  md-sort-by="KOSHIN_NICHIJI"
                  :class="{ 'bg-blue white': isMobile }"
                >
                  <span v-if="!isMobile">
                    {{ dateFormat(item.KOSHIN_NICHIJI) }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">登録日</p>
                    <p class="col-9 p-0">
                      {{ dateFormat(item.KOSHIN_NICHIJI) }}
                    </p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="タイトル" md-sort-by="TITLE">
                  <span v-if="!isMobile">{{ omitText(item.TITLE, 26) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">タイトル</p>
                    <p class="col-9 p-0">{{ item.TITLE }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="メッセージ" md-sort-by="MESSAGE">
                  <span v-if="!isMobile">{{ omitText(item.MESSAGE, 45) }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold blue">メッセージ</p>
                    <p class="col-9 p-0">{{ item.MESSAGE }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="">
                  <toggle-button
                    color="#82C7EB"
                    :value="Boolean(item.IS_DISPLAY_FLG)"
                    :v-model="item.IS_DISPLAY_FLG"
                    @change="saveInfoDisplay(item)"
                    :sync="true"
                    :labels="{ checked: '公開', unchecked: '非公開' }"
                    :width="isPC ? 95 : 75"
                    :height="isPC ? 32 : 28"
                    :font-size="isPC ? 16 : 12"
                  />
                  <b-button
                    class="btn-secondary list-btn sp-fs-14"
                    @click="
                      del.info = item.ID
                      isDeleteInfoConfirm = true
                    "
                  >
                    削除
                  </b-button>
                  <b-button
                    class="btn-success list-btn sp-fs-14"
                    @click="
                      editInfo(item)
                      showEditInfoDialog = true
                    "
                  >
                    編集
                  </b-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center my-5 bold">
              該当するお知らせはありません。
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 登録完了 -->
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isSaved"
      md-content="<strong>登録しました。</strong>"
    />

    <!-- 削除確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteAccount()"
      @md-cancel="delreset"
    />
    <!-- お知らせ削除確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteInfoConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteInfo()"
      @md-cancel="delreset"
    />
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleted"
      md-content="<strong>削除しました。</strong>"
    />
    <!-- グループ削除確認 -->
    <md-dialog-confirm
      class="new z-100"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteGroupConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteGroup()"
      @md-cancel="delreset"
    />

    <!-- アカウント編集モーダル -->
    <md-dialog
      id="account-dialog"
      :md-active.sync="showEditDialog"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>アカウント登録</md-dialog-title>
      <div class="p-md-4">
        <table class="table">
          <tr v-if="isNewAccMdlFlg">
            <th>
              権限
              <span class="must">必須</span>
            </th>
            <td>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="role-radio-1"
                  value="members"
                  v-model="mdlAccount.ROLE"
                />
                <label class="form-check-label" for="role-radio-1">顧客</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="role-radio-2"
                  value="admin"
                  v-model="mdlAccount.ROLE"
                  disabled
                />
                <label class="form-check-label" for="role-radio-2">
                  ロジコ社員（管理者）
                </label>
              </div>
              <p class="red f-size-12 mt-2">
                ※管理者はアカウント数の上限に達した為作成できません。
              </p>
            </td>
          </tr>
          <tr v-if="!isNewAccMdlFlg">
            <th>ID</th>
            <td>{{ mdlAccount.USER_ID }}</td>
          </tr>
          <tr v-if="mdlAccount.ROLE !== 'admin'">
            <th>会社名</th>
            <td>
              <vue-simple-suggest
                ref="companySuggest"
                :class="[
                  'px-0',
                  { 'border-red': $v.mdlAccount.JYUCYU_SHIKI_CD.$error },
                ]"
                v-model="mdlAccount.SOFU_SAKI_MEI"
                :max-suggestions="15"
                :list="companyList"
                :styles="autoCompleteStyle"
                @select="
                  mdlAccount.JYUCYU_SHIKI_CD =
                    $refs.companySuggest.selected.JYUCYU_SHIKI_CD
                "
                @focus="$v.mdlAccount.JYUCYU_SHIKI_CD.$touch()"
                placeholder="株式会社ロジコ"
                :filter-by-query="true"
                value-attribute="JYUCYU_SHIKI_CD"
                display-attribute="SOFU_SAKI_MEI"
              />
              <div
                v-if="$v.mdlAccount.JYUCYU_SHIKI_CD.$error"
                class="err-message col-md-6"
              >
                <p v-if="!$v.mdlAccount.JYUCYU_SHIKI_CD.required">
                  存在しない会社です。
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <th>
              お名前
              <span class="must">必須</span>
            </th>
            <td>
              <label class="d-inline mt-sm-2 mr-2">姓</label>
              <input
                type="text"
                :class="[
                  'form-control d-inline col-md-4',
                  { 'border-red': $v.mdlAccount.TANTO_MEI_SEI.$error },
                ]"
                @change="$v.mdlAccount.TANTO_MEI_SEI.$touch()"
                v-model="mdlAccount.TANTO_MEI_SEI"
                :maxlength="$v.mdlAccount.TANTO_MEI_SEI.$params.maxLength.max"
                placeholder="山田"
              />
              <div
                v-if="isMobile && $v.mdlAccount.TANTO_MEI_SEI.$error"
                class="err-message"
              >
                <span v-if="!$v.mdlAccount.TANTO_MEI_SEI.required">
                  入力必須です
                </span>
                <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.isEmoji">
                  絵文字は入力できません
                </span>
                <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.zenkaku">
                  全角で入力してください
                </span>
                <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.maxLength">
                  {{
                    $v.mdlAccount.TANTO_MEI_SEI.$params.maxLength.max
                  }}桁で入力してください
                </span>
              </div>
              <label class="d-inline mt-2 ml-sm-4 mr-2">名</label>
              <input
                type="text"
                :class="[
                  'form-control d-inline col-md-4',
                  { 'border-red': $v.mdlAccount.TANTO_MEI.$error },
                ]"
                @change="$v.mdlAccount.TANTO_MEI.$touch()"
                v-model="mdlAccount.TANTO_MEI"
                :maxlength="$v.mdlAccount.TANTO_MEI.$params.maxLength.max"
                placeholder="太郎"
              />
              <div
                v-if="isMobile && $v.mdlAccount.TANTO_MEI.$error"
                class="err-message"
              >
                <span v-if="!$v.mdlAccount.TANTO_MEI.isEmoji">
                  絵文字は入力できません
                </span>
                <span v-else-if="!$v.mdlAccount.TANTO_MEI.zenkaku">
                  全角で入力してください
                </span>
                <span v-else-if="!$v.mdlAccount.TANTO_MEI.maxLength">
                  {{
                    $v.mdlAccount.TANTO_MEI.$params.maxLength.max
                  }}桁で入力してください
                </span>
              </div>
              <div
                v-if="
                  !isMobile &&
                  ($v.mdlAccount.TANTO_MEI_SEI.$error ||
                    $v.mdlAccount.TANTO_MEI.$error)
                "
              >
                <div class="row">
                  <div class="err-message d-inline col-md-5">
                    <div v-if="$v.mdlAccount.TANTO_MEI_SEI.$error">
                      <label class="d-inline mt-2 ml-sm-4 mr-2" />
                      <span v-if="!$v.mdlAccount.TANTO_MEI_SEI.required">
                        入力必須です
                      </span>
                      <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.isEmoji">
                        絵文字は入力できません
                      </span>
                      <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.zenkaku">
                        全角で入力してください
                      </span>
                      <span v-else-if="!$v.mdlAccount.TANTO_MEI_SEI.maxLength">
                        {{
                          $v.mdlAccount.TANTO_MEI_SEI.$params.maxLength.max
                        }}桁で入力してください
                      </span>
                    </div>
                  </div>
                  <div class="err-message d-inline col-md-5">
                    <div v-if="$v.mdlAccount.TANTO_MEI.$error">
                      <label class="d-inline mt-2 ml-sm-2 mr-2" />
                      <span v-if="!$v.mdlAccount.TANTO_MEI.isEmoji">
                        絵文字は入力できません
                      </span>
                      <span v-else-if="!$v.mdlAccount.TANTO_MEI.zenkaku">
                        全角で入力してください
                      </span>
                      <span v-else-if="!$v.mdlAccount.TANTO_MEI.maxLength">
                        {{
                          $v.mdlAccount.TANTO_MEI.$params.maxLength.max
                        }}桁で入力してください
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="mdlAccount.ROLE !== 'admin'">
            <th>グループ</th>
            <td>
              <select
                class="d-inline form-control col-md-8"
                v-model="mdlAccount.NAVI_GROUP_ID"
              >
                <option value="" key="" selected>選択なし</option>
                <option
                  v-for="(item, key) in groups"
                  :value="item.ID"
                  :key="key"
                >
                  {{ item.NAME }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>
              メールアドレス
              <span class="must">必須</span>
            </th>
            <td>
              <input
                type="email"
                :class="[
                  'd-inline form-control col-lg-8',
                  { 'border-red': $v.mdlAccount.MAIL_ADDR.$error },
                ]"
                @change="
                  isEmailChecked = false
                  $v.mdlAccount.MAIL_ADDR.$touch()
                  checkEmail()
                "
                v-model="mdlAccount.MAIL_ADDR"
                :maxlength="$v.mdlAccount.MAIL_ADDR.$params.maxLength.max"
                placeholder="tanaka@mail.co.jp"
              />
              <div
                v-if="$v.mdlAccount.MAIL_ADDR.$error || isEmailError"
                class="err-message col-md-6"
              >
                <p v-if="!$v.mdlAccount.MAIL_ADDR.required">入力必須です</p>
                <p v-else-if="!$v.mdlAccount.MAIL_ADDR.email">
                  正しい形式で入力してください
                </p>
                <p v-else-if="!$v.mdlAccount.MAIL_ADDR.maxLength">
                  {{
                    $v.mdlAccount.MAIL_ADDR.$params.maxLength.max
                  }}文字以下で入力してください
                </p>
                <p v-else-if="isEmailError">存在するメールアドレスです。</p>
              </div>
            </td>
          </tr>
          <tr v-if="!isNewAccMdlFlg && !isInitialAccount">
            <th>パスワード</th>
            <td>
              <input
                type="password"
                :class="[
                  'd-inline form-control col-10 col-lg-8',
                  { 'border-red': $v.mdlAccount.PASSWORD.$error },
                ]"
                @change="
                  $v.mdlAccount.PASSWORD.$touch()
                  changePassword()
                "
                v-model="mdlAccount.PASSWORD"
                :maxlength="$v.mdlAccount.PASSWORD.$params.maxLength.max"
              />
              <font-awesome-icon
                icon="eye"
                class="eye-icon"
                @click="showAccountPW()"
              />
              <div
                v-if="$v.mdlAccount.PASSWORD.$error"
                class="err-message col-md-6"
              >
                <p v-if="!$v.mdlAccount.PASSWORD.required">入力必須です</p>
                <p v-if="!$v.mdlAccount.PASSWORD.psw">
                  半角英字と半角数字は1文字以上使用してください。
                </p>
                <p v-else-if="!$v.mdlAccount.PASSWORD.minLength">
                  {{
                    $v.mdlAccount.PASSWORD.$params.minLength.min
                  }}文字以上で入力してください
                </p>
                <p v-else-if="!$v.mdlAccount.PASSWORD.maxLength">
                  {{
                    $v.mdlAccount.PASSWORD.$params.maxLength.max
                  }}文字以下で入力してください
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="!isNewAccMdlFlg && !isInitialAccount">
            <th>パスワード（確認）</th>
            <td>
              <input
                type="password"
                :class="[
                  'form-control col-10 col-lg-8',
                  { 'border-red': $v.mdlAccount.CONFIRM.$error },
                ]"
                @change="$v.mdlAccount.CONFIRM.$touch()"
                v-model="mdlAccount.CONFIRM"
              />
              <div
                v-if="$v.mdlAccount.CONFIRM.$error"
                class="err-message col-md-6"
              >
                <p v-if="!$v.mdlAccount.CONFIRM.required">入力必須です</p>
                <p v-else-if="!$v.mdlAccount.CONFIRM.sameAs">
                  パスワードが一致していません。
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="!isNewAccMdlFlg && !isInitialAccount">
            <th>手配完了メールの配信</th>
            <td>
              <div class="ml-4">
                <md-checkbox
                  class="form-check-input md-primary"
                  v-model.number="mdlAccount.TEHAI_KANRYO_MAIL"
                  :true-value="1"
                  :false-value="0"
                >
                  希望する
                </md-checkbox>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <!-- パスワード -->
      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isDisplayPW"
        :md-content="mdlAccount.pw"
      />

      <md-dialog-actions>
        <md-button class="md-primary" @click="showEditDialog = false">
          閉じる
        </md-button>
        <md-button
          class="md-primary"
          @click="saveAccount()"
          :disabled="isError"
        >
          登録
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- お知らせ編集モーダル -->
    <md-dialog
      id="info-dialog"
      :md-active.sync="showEditInfoDialog"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="
        $v.mdlInfo.$reset()
        scroll('clear')
      "
    >
      <md-dialog-title>お知らせ登録</md-dialog-title>
      <div class="p-md-4">
        <table class="table">
          <tr>
            <th>登録日</th>
            <td>
              <input
                v-if="isEnableDatepicker"
                type="date"
                :class="[
                  'form-control col-md-5',
                  { 'border-red': $v.mdlInfo.KOSHIN_NICHIJI.$error },
                ]"
                placeholder="2019/01/01"
                v-model="mdlInfo.KOSHIN_NICHIJI"
                @change="$v.mdlInfo.KOSHIN_NICHIJI.$touch()"
              />
              <Datepicker
                v-else
                :clear-button="true"
                :format="datePickerFormat"
                :language="ja"
                :class="[
                  'col-md-5 p-0',
                  { 'border-red': $v.mdlInfo.KOSHIN_NICHIJI.$error },
                ]"
                placeholder="2019/01/01"
                v-model="mdlInfo.KOSHIN_NICHIJI"
                @input="
                  mdlInfo.KOSHIN_NICHIJI = dateObjToStr(mdlInfo.KOSHIN_NICHIJI)
                  $v.mdlInfo.KOSHIN_NICHIJI.$touch()
                "
              />
              <div
                v-if="$v.mdlInfo.KOSHIN_NICHIJI.$error"
                class="err-message row col-md-6"
              >
                <p v-if="!$v.mdlInfo.KOSHIN_NICHIJI.isValidDate">
                  yyyy-mm-dd 形式で入力してください
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <th>
              タイトル
              <span class="must">必須</span>
            </th>
            <td>
              <input
                type="text"
                v-model="mdlInfo.TITLE"
                :class="[
                  'form-control',
                  { 'border-red': $v.mdlInfo.TITLE.$error },
                ]"
              />
              <div v-if="$v.mdlInfo.TITLE.$error" class="err-message col-md-6">
                <p v-if="!$v.mdlInfo.TITLE.required">入力必須です</p>
                <p v-else-if="!$v.mdlInfo.TITLE.isEmoji">
                  絵文字は入力できません
                </p>
                <p v-else-if="!$v.mdlInfo.TITLE.maxLength">
                  50文字以下で入力してください
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <th>
              メッセージ
              <span class="must">必須</span>
            </th>
            <td>
              <textarea
                v-model="mdlInfo.MESSAGE"
                :class="[
                  'form-control form-control',
                  { 'border-red': $v.mdlInfo.MESSAGE.$error },
                ]"
                rows="5"
              />
              <div
                v-if="$v.mdlInfo.MESSAGE.$error"
                class="err-message col-md-6"
              >
                <p v-if="!$v.mdlInfo.MESSAGE.required">入力必須です</p>
                <p v-else-if="!$v.mdlInfo.MESSAGE.isEmoji">
                  絵文字は入力できません
                </p>
                <p v-else-if="!$v.mdlInfo.MESSAGE.maxLength">
                  400文字以下で入力してください
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showEditInfoDialog = false">
          閉じる
        </md-button>
        <md-button class="md-primary" @click="saveInfoBody()">登録</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- グループ管理モーダル -->
    <md-dialog
      :md-active.sync="showGroupDialog"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="
        groupMode = 'index'
        scroll('clear')
      "
    >
      <md-dialog-title>{{ groupTitle }}</md-dialog-title>
      <div v-if="groupMode === 'add' || groupMode === 'edit'">
        <div
          id="group-dialog"
          v-if="groupInputPage === 1"
          class="torihiki_list"
        >
          <div class="p-2 p-md-4">
            <div class="ml-md-3 mb-1 mb-md-2 search-wrapper">
              <div class="mb-md-4">
                <label
                  class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 pl-md-4 my-0 mt-2 mt-md-0"
                >
                  会社名
                </label>
                <input
                  type="text"
                  class="d-inline form-control col-md-8"
                  v-model="search.torihiki.name"
                  @change="setTorihiki()"
                />
              </div>
              <p class="f-size-14 sp-fs-12 red">
                ※会社名を検索し、グループに設定する会社全てにチェックを入れてください。
              </p>
              <md-table
                v-if="torihikis.length"
                class="mt-2 mb-4 p-2 bg-gray black-svg h-250"
                v-model="torihikis"
                md-sort="KOSHIN_NICHIJI"
                md-sort-order="desc"
                md-card
                md-fixed-header
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <label :for="`torihiki-${item.JYUCYU_SHIKI_CD}`">
                    <md-table-cell v-if="!isMobile" md-label="">
                      <input
                        type="checkbox"
                        :id="`torihiki-${item.JYUCYU_SHIKI_CD}`"
                        :value="item"
                        v-model="group.TORIHIKI_SAKI"
                      />
                    </md-table-cell>

                    <md-table-cell md-label="会社名" md-sort-by="SOFU_SAKI_MEI">
                      <span v-if="!isMobile">
                        {{ omitText(item.SOFU_SAKI_MEI, 100) }}
                        <br />
                        （TEL: {{ item.TORIHIKI_SAKI_TEL }}）
                      </span>
                      <div v-else class="row">
                        <input
                          type="checkbox"
                          :id="`torihiki-${item.JYUCYU_SHIKI_CD}`"
                          :value="item.JYUCYU_SHIKI_CD"
                          v-model="group.TORIHIKI_SAKI"
                          class="mt-1"
                        />
                        <span class="col-3 p-0 bold">会社名</span>
                        <p class="col-8 p-0 text-left">
                          {{ item.SOFU_SAKI_MEI }}
                          <br />
                          （TEL: {{ item.TORIHIKI_SAKI_TEL }}）
                        </p>
                      </div>
                    </md-table-cell>
                  </label>
                </md-table-row>
              </md-table>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="groupMode = 'index'">
              もどる
            </md-button>
            <md-button
              class="md-primary"
              @click="groupInputPage = 2"
              :disabled="!group.TORIHIKI_SAKI.length"
            >
              次へ
            </md-button>
          </md-dialog-actions>
        </div>
        <div id="group-edit-modal" v-else-if="groupInputPage === 2">
          <div class="p-md-4">
            <p class="f-size-14 sp-fs-12 red">
              ※会社名は1件以上入力してください
            </p>
            <table class="table">
              <tr>
                <th>
                  グループ名
                  <span class="must">必須</span>
                </th>
                <td>
                  <input
                    type="text"
                    v-model="group.NAME"
                    :class="[
                      'col-lg-8 form-control',
                      { 'border-red': $v.group.NAME.$error },
                    ]"
                    maxlength="20"
                  />
                  <div v-if="$v.group.NAME.$error" class="err-message col-md-6">
                    <p v-if="!$v.group.NAME.required">入力必須です</p>
                    <p v-else-if="!$v.group.NAME.isEmoji">
                      絵文字は入力できません
                    </p>
                    <p v-else-if="!$v.group.NAME.maxLength">
                      20文字以下で入力してください
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>memo</th>
                <td>
                  <textarea
                    v-model="group.MEMO"
                    :class="[
                      'form-control form-control',
                      { 'border-red': $v.group.MEMO.$error },
                    ]"
                    rows="5"
                    maxlength="400"
                  />
                  <div v-if="$v.group.MEMO.$error" class="err-message col-md-6">
                    <p v-if="!$v.group.MEMO.isEmoji">絵文字は入力できません</p>
                    <p v-else-if="!$v.group.MEMO.maxLength">
                      400文字以下で入力してください
                    </p>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="groupInputPage = 1">
              もどる
            </md-button>
            <md-button class="md-primary" @click="saveGroup()">登録</md-button>
          </md-dialog-actions>
        </div>
      </div>
      <div v-else class="list">
        <div class="p-md-4">
          <div class="text-right mb-1">
            <b-button
              class="btn btn-success sp-fs-14 mb-2"
              @click="
                clearGroup()
                groupMode = 'add'
                groupInputPage = 1
              "
            >
              新規作成
            </b-button>
          </div>
          <p class="f-size-14 sp-fs-12 red px-2">
            ※各アカウントでグループ機能を有効にするためには、アカウント登録画面でグループを選択する必要があります。
          </p>
          <md-table
            v-if="groups.length"
            class="mb-4 p-2 bg-gray black-svg h-300"
            v-model="groups"
            md-sort="KOSHIN_NICHIJI"
            md-sort-order="desc"
            md-card
            md-fixed-header
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                md-label="更新日"
                md-sort-by="KOSHIN_NICHIJI"
                :class="{ 'bg-blue white': isMobile }"
              >
                <span v-if="!isMobile">
                  {{ dateFormat(item.KOSHIN_NICHIJI) }}
                </span>
                <div v-else class="row">
                  <p class="col-3 p-0 bold">更新日</p>
                  <p class="col-9 p-0">{{ dateFormat(item.KOSHIN_NICHIJI) }}</p>
                </div>
              </md-table-cell>

              <md-table-cell md-label="グループ名" md-sort-by="NAME">
                <span v-if="!isMobile">{{ omitText(item.NAME, 20) }}</span>
                <div v-else class="row">
                  <p class="col-3 p-0 bold blue">グループ名</p>
                  <p class="col-9 p-0">{{ item.NAME }}</p>
                </div>
              </md-table-cell>

              <md-table-cell md-label="memo" md-sort-by="MEMO">
                <span v-if="!isMobile">{{ omitText(item.MEMO, 50) }}</span>
                <div v-else class="row">
                  <p class="col-3 p-0 bold blue">memo</p>
                  <p class="col-9 p-0">{{ item.MEMO }}</p>
                </div>
              </md-table-cell>

              <md-table-cell md-label="" class="p-0">
                <b-button
                  class="btn-secondary list-btn sp-fs-14"
                  @click="
                    del.group = item
                    isDeleteGroupConfirm = true
                  "
                >
                  削除
                </b-button>
                <b-button
                  class="btn-success list-btn sp-fs-14"
                  @click="
                    setGroup(item)
                    groupMode = 'edit'
                    groupInputPage = 1
                  "
                >
                  編集
                </b-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showGroupDialog = false">
            閉じる
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isSent"
      md-content="<strong>アカウントが再アクティベートされました</strong>"
    />

    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="showUpdatedInfoDialog"
      md-content="<strong>お知らせ情報を更新しました</strong>"
    />

    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isChangedEMail"
      md-content="<strong>メールアドレスは、変更したアドレス宛に送信される<br>アクティベートメール内のリンクがクリックされた時点で変更されます。</strong>"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Valid from '@/valid'
import {
  required,
  maxLength,
  minLength,
  email,
  sameAs,
  requiredIf,
} from 'vuelidate/lib/validators'
import Mixin from '../mixin/Mixin'
import Constant from '@/const'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import Store from '@/store/index.js'
import Datepicker from 'vuejs-datepicker'

// カスタムバリデーション
const psw = (value) => Valid.isValidPassword(value) // パスワードバリデーション
const zenkaku = (value) => Valid.isZenkaku(value)
const isValidDate = (value) => Valid.isValidDate(value)
const isEmoji = (value) => Valid.isEmoji(value)

const MAX_TABLE_RECORD = 10 // テーブルにスクロールしないで表示するレコード数の最大値
const ROW_HEIGHT = 65
const ROW_GROUP_HEIGHT = 50
const ACC_LIMIT = 25 // アカウント件数
const INFO_LIMIT = 25 // インフォ件数
const GROUP_TORIHIKI_MAX = 5 // グループに設定できる取引先の最大数

export default {
  name: 'Edit',
  components: {
    VueSimpleSuggest,
    Datepicker,
  },
  mixins: [validationMixin, Mixin],
  data: () => ({
    async: {
      info: false,
      accounts: false,
    },
    // サジェスト設定
    autoCompleteStyle: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    isDisplayPW: false,
    showEditDialog: false,
    showEditInfoDialog: false,
    isDeleteConfirm: false,
    isDeleteInfoConfirm: false,
    isDeleteGroupConfirm: false,
    showGroupDialog: false,
    showUpdatedInfoDialog: false,
    isDeleted: false,
    isSaved: false,
    isSent: false,
    isChangedEMail: false,
    switch1: true,
    switch2: false,
    switch3: false,
    switch4: false,
    isNewAccMdlFlg: false,
    groupMode: 'index',
    infomations: {
      title: '',
      body: [],
    },
    accounts: [],
    companyMap: { id: [], name: [] },
    /** アカウントモーダルの会社名リスト **/
    companyList: [],
    search: {
      acc: {
        name: '',
        mail: '',
        company: '',
        status: '',
        from: '',
        to: '',
        user_id: '',
        group_name: '',
      },
      info: {
        title: '',
        message: '',
        from: '',
        to: '',
      },
      torihiki: {
        shiki_cds: [],
        name,
      },
    },
    del: {
      info: '',
      group: {},
    },
    isEmailError: false,
    isEmailChecked: true,
    mdlAccount: {
      ID: '',
      USER_ID: '',
      JYUCYU_SHIKI_CD: '',
      TANTO_MEI_SEI: '',
      TANTO_MEI: '',
      NAVI_GROUP_ID: '',
      STATUS: '',
      MAIL_ADDR: '',
      NEW_PASSWORD: '',
      PASSWORD: '',
      CONFIRM: '',
      DELETE_NICHIJI: '',
      pw: '',
      ROLE: '',
      TEHAI_KANRYO_MAIL: 0,
    },
    mdlInfo: {
      ID: '',
      TITLE: '',
      MESSAGE: '',
      KOSHIN_NICHIJI: '',
    },
    isSetGroup: false,
    groupInputPage: 1,
    groups: [],
    group: {
      ID: '',
      NAME: '',
      MEMO: '',
      TORIHIKI_SAKI: [],
    },
    torihikis: [],
  }),
  validations() {
    let valid = {
      mdlAccount: {
        JYUCYU_SHIKI_CD: {
          required: requiredIf(function () {
            return this.mdlAccount.ROLE !== Constant.USER.ROLE.ADMIN
          }),
        },
        TANTO_MEI_SEI: {
          required,
          isEmoji,
          zenkaku,
          maxLength: maxLength(30),
        },
        TANTO_MEI: {
          isEmoji,
          zenkaku,
          maxLength: maxLength(30),
        },
        MAIL_ADDR: {
          required,
          email,
          maxLength: maxLength(50),
        },
      },
      mdlInfo: {
        TITLE: {
          required,
          isEmoji,
          maxLength: maxLength(50),
        },
        MESSAGE: {
          required,
          isEmoji,
          maxLength: maxLength(400),
        },
        KOSHIN_NICHIJI: {
          isValidDate,
        },
      },
      group: {
        NAME: {
          required,
          isEmoji,
          maxLength: maxLength(20),
        },
        MEMO: {
          isEmoji,
          maxLength: maxLength(400),
        },
      },
    }
    // 編集する場合はPWのチェックを行う
    if (!this.isNewAccMdlFlg && !this.isInitialAccount) {
      valid.mdlAccount.PASSWORD = {
        minLength: minLength(6),
        maxLength: maxLength(16),
      }
      valid.mdlAccount.CONFIRM = {
        sameAs: sameAs('PASSWORD'),
      }
      // 編集時にPWが空の場合は必須チェックをしない->PW変更は行わない
      if (this.mdlAccount.PASSWORD || this.mdlAccount.CONFIRM) {
        valid.mdlAccount.PASSWORD.required = required
        valid.mdlAccount.PASSWORD.psw = psw
        valid.mdlAccount.CONFIRM.required = required
      }
    }
    return valid
  },
  methods: {
    // 承認メール
    sendMail(data) {
      Store.dispatch('account/reSendValidMail', data)
        .then((res) => {
          this.setAccount()
          this.isSent = true
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    accModalClose() {
      this.isEmailError = false
      this.isEmailChecked = true
      this.$v.mdlAccount.$reset()
      this.scroll('clear')
    },
    // メールアドレス重複チェック
    checkEmail() {
      /*
      this.validEmail(this.mdlAccount.ID,
        this.mdlAccount.MAIL_ADDR, this.mdlAccount.ROLE)
        .then(res => {
          if (res.data) this.isEmailError = true
          else this.isEmailError = false
          this.isEmailChecked = true
        }).catch(err => {
          throw new Error(err.message)
        })
        */
      this.isEmailChecked = true
    },
    /**
     * 取引先取得
     */
    setCompany() {
      this.getCompany()
        .then((res) => {
          let list = []
          for (const item of res.data) {
            item.SOFU_SAKI_MEI = `${item.SOFU_SAKI_MEI}（TEL: ${item.TORIHIKI_SAKI_TEL}）`
            list.push(item)
            this.companyMap['id'][item.SOFU_SAKI_MEI] = item.JYUCYU_SHIKI_CD
            this.companyMap['name'][String(item.JYUCYU_SHIKI_CD)] =
              item.SOFU_SAKI_MEI
          }
          this.companyList = list
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    // グループ設定の取引先一覧
    setTorihiki() {
      this.search.torihiki.shiki_cds = []
      for (const d of this.group.TORIHIKI_SAKI) {
        this.search.torihiki.shiki_cds.push(d.JYUCYU_SHIKI_CD)
      }
      this.getCompany(this.search.torihiki)
        .then((res) => {
          if (res.data.length) {
            let pre = []
            let back = []
            let checked = []
            for (const d of this.group.TORIHIKI_SAKI) {
              checked.push(d.JYUCYU_SHIKI_CD)
            }
            for (const d of res.data) {
              if (checked.indexOf(d.JYUCYU_SHIKI_CD) >= 0) pre.push(d)
              else back.push(d)
            }
            this.torihikis = pre.concat(back)
          } else {
            this.torihikis = []
            this._info('該当する取引先は存在しません。')
          }
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    /**
     * アカウント取得
     */
    setAccount() {
      this.async.accounts = true
      this.search.acc.limit = ACC_LIMIT
      this.getAccount(this.search.acc)
        .then((res) => {
          this.accounts = res.data
          this.async.accounts = false
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    showAccountPW() {
      this.getPwd(this.mdlAccount.ID).then((pwd) => {
        this.isDisplayPW = true
        this.mdlAccount.pw = pwd
      })
    },
    getPwd(userId) {
      return this.getAccountPW(userId)
        .then((res) => {
          return res.data.pw
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    /**
     * アカウント新規作成
     */
    newAccount() {
      this.mdlAccount.ID = ''
      this.mdlAccount.JYUCYU_SHIKI_CD = ''
      this.mdlAccount.SOFU_SAKI_MEI = ''
      this.mdlAccount.TANTO_MEI_SEI = ''
      this.mdlAccount.TANTO_MEI = ''
      this.mdlAccount.NAVI_GROUP_ID = ''
      this.mdlAccount.STATUS = Constant.USER.STATUS.INITIAL
      this.mdlAccount.MAIL_ADDR = ''
      this.mdlAccount.PASSWORD = ''
      this.mdlAccount.TEHAI_KANRYO_MAIL = 0
      this.mdlAccount.CONFIRM = ''
      this.mdlAccount.DELETE_NICHIJI = ''
      this.mdlAccount.ROLE = 'members'
      this.isNewAccMdlFlg = true
      this.showEditDialog = true
    },
    /**
     * アカウント編集
     */
    async editAccount(item) {
      this.mdlAccount.ID = item.TANTO_ID
      this.mdlAccount.USER_ID = item.USER_ID
      this.mdlAccount.JYUCYU_SHIKI_CD = item.JYUCYU_SHIKI_CD
      this.mdlAccount.SOFU_SAKI_MEI = this.companyMap['name'][
        item.JYUCYU_SHIKI_CD
      ]
      this.mdlAccount.TANTO_MEI_SEI = item.TANTO_MEI_SEI
      this.mdlAccount.TANTO_MEI = item.TANTO_MEI
      this.mdlAccount.NAVI_GROUP_ID = item.NAVI_GROUP_ID || ''
      this.mdlAccount.STATUS = item.STATUS
      this.mdlAccount.MAIL_ADDR = item.MAIL_ADDR
      if (this.isInitialAccount) {
        this.mdlAccount.PASSWORD = ''
        this.mdlAccount.CONFIRM = ''
        this.mdlAccount.TEHAI_KANRYO_MAIL = 0
      } else {
        const pwd = await this.getPwd(item.TANTO_ID)
        this.mdlAccount.PASSWORD = pwd
        this.mdlAccount.CONFIRM = pwd
        this.mdlAccount.TEHAI_KANRYO_MAIL = item.TEHAI_KANRYO_MAIL
      }
      // this.mdlAccount.DELETE_NICHIJI = ''
      this.mdlAccount.pw = ''
      this.isNewAccMdlFlg = false
      this.showEditDialog = true

      this.PRE_MAIL_ADDR = item.MAIL_ADDR
      this.$v.mdlAccount.$touch()
    },
    /**
     * 削除アカウント設定
     */
    delset(item) {
      this.mdlAccount.ID = item.TANTO_ID
      this.mdlAccount.STATUS = item.STATUS
    },
    /**
     * 削除アカウントリセット
     */
    delreset() {
      this.mdlAccount.ID = ''
      this.mdlAccount.STATUS = ''
    },
    /**
     * アカウント登録
     */
    saveAccount() {
      this.$v.$touch()
      if (this.$v.mdlAccount.$invalid) return
      this.showEditDialog = false

      delete this.mdlAccount.CONFIRM
      delete this.mdlAccount.DELETE_NICHIJI
      if (this.mdlAccount.ID !== '') {
        if (this.mdlAccount.NEW_PASSWORD !== this.mdlAccount.PASSWORD) {
          delete this.mdlAccount.PASSWORD
        }
        delete this.mdlAccount.NEW_PASSWORD
        return Store.dispatch('account/updateAccount', this.mdlAccount)
          .then((res) => {
            this._info('アカウントを更新しました。')
            if (this.PRE_MAIL_ADDR !== this.mdlAccount.MAIL_ADDR)
              this.isChangedEMail = true
            this.setAccount()
            this.showEditDialog = false
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      } else {
        delete this.mdlAccount.NEW_PASSWORD
        return Store.dispatch('account/setAccount', this.mdlAccount)
          .then((res) => {
            this._info('アカウントを作成しました。')
            this.setAccount()
            this.showEditDialog = false
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      }
    },
    changePassword() {
      this.mdlAccount.NEW_PASSWORD = this.mdlAccount.PASSWORD
    },
    /**
     * アカウント削除
     */
    deleteAccount() {
      if (this.mdlAccount.STATUS !== Constant.USER.STATUS.INITIAL) {
        this.mdlAccount.DELETE_NICHIJI = this.getNichiji()
        return Store.dispatch('account/updateAccount', this.mdlAccount)
          .then((res) => {
            this.setAccount()
            this.isDeleted = true
          })
          .catch((err) => {
            throw new Error(err.message)
          })
      } else {
        delete this.mdlAccount.NEW_PASSWORD
        delete this.mdlAccount.DELETE_NICHIJI
        return Store.dispatch('account/delAccount', this.mdlAccount)
          .then((res) => {
            this.setAccount()
            this.isDeleted = true
          })
          .catch((err) => {
            throw new Error(err.message)
          })
      }
    },
    /**
     * お知らせ新規作成
     */
    newInfo() {
      this.mdlInfo.ID = ''
      this.mdlInfo.TITLE = ''
      this.mdlInfo.MESSAGE = ''
      this.mdlInfo.KOSHIN_NICHIJI = this.getToday()
      this.mdlInfo.IS_DISPLAY_FLG = 0
    },
    /**
     * お知らせ編集
     */
    editInfo(item) {
      this.mdlInfo.ID = item.ID
      this.mdlInfo.TITLE = item.TITLE
      this.mdlInfo.MESSAGE = item.MESSAGE
      this.mdlInfo.KOSHIN_NICHIJI = this.dateFormat(item.KOSHIN_NICHIJI)
    },
    // お知らせタイトル登録
    saveInfoTitle() {
      this.saveInfo(
        {
          title: this.infomations.title,
        },
        false,
        true
      )
    },
    // お知らせ本文登録
    saveInfoBody() {
      this.$v.mdlInfo.$touch()
      if (this.$v.mdlInfo.$invalid) {
        return
      }
      this.showEditInfoDialog = false
      this.saveInfo({
        body: this.mdlInfo,
      })
    },
    // グループ取得
    setGroupList() {
      return Store.dispatch('group/get')
        .then((res) => {
          this.isSetGroup = true
          this.groups = res.data
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    // グループ保存
    async saveGroup() {
      this.$v.group.$touch()
      if (this.$v.group.$invalid) return
      this.invisibleFilterOn()
      const url = this.groupMode === 'add' ? 'group/add' : 'group/edit'
      await Store.dispatch(url, this.group)
        .then(async (res) => {
          if (this.groupMode === 'edit') this.setAccount()
          await this.setGroupList()
          this._info('登録が完了しました。')
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
      this.invisibleFilterOff()
      this.groupMode = 'index'
    },
    async deleteGroup() {
      this.invisibleFilterOn()
      await Store.dispatch('group/delete', this.del.group)
        .then(async (res) => {
          this.setAccount()
          await this.setGroupList()
          this._info('削除が完了しました。')
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
      this.invisibleFilterOff()
      this.groupMode = 'index'
    },
    setGroup(data) {
      this.clearGroup()
      this.group.ID = data.ID
      this.group.NAME = data.NAME
      this.group.MEMO = data.MEMO
      for (const d of data.group_torihiki) {
        this.group.TORIHIKI_SAKI.push({
          JYUCYU_SHIKI_CD: d.JYUCYU_SHIKI_CD,
          SOFU_SAKI_MEI: d.SOFU_SAKI_MEI,
          TORIHIKI_SAKI_TEL: d.TORIHIKI_SAKI_TEL,
        })
      }
      this.setTorihiki()
    },
    clearGroup() {
      this.torihikis = []
      this.search.torihiki = {
        name: '',
        shiki_cds: [],
      }
      this.group = {
        ID: '',
        NAME: '',
        MEMO: '',
        TORIHIKI_SAKI: [],
      }
      this.$v.group.$reset()
    },
    // お知らせ表示ステータス登録
    saveInfoDisplay(item) {
      this.editInfo(item)
      this.mdlInfo.IS_DISPLAY_FLG = !item.IS_DISPLAY_FLG
      item.IS_DISPLAY_FLG = !item.IS_DISPLAY_FLG
      this.saveInfo(
        {
          body: this.mdlInfo,
        },
        false
      )
    },
    // お知らせ登録
    saveInfo(params, isReload = true, isUpdatedMdl = false) {
      Store.dispatch('info/save', params)
        .then((res) => {
          if (isReload) this.setInfo()
          if (isUpdatedMdl) this.showUpdatedInfoDialog = true
        })
        .catch((err) => {
          this._alert(err.message, false)
          throw new Error(err.message)
        })
    },
    // お知らせ削除
    deleteInfo() {
      Store.dispatch('info/delete', { ID: this.del.info })
        .then((res) => {
          // this.isSaved = true
          this.setInfo()
        })
        .catch((err) => {
          this._alert(err.message, false)
          throw new Error(err.message)
        })
    },
    // お知らせ取得
    setInfo() {
      this.async.info = true
      this.search.info.limit = INFO_LIMIT
      this.getInfo(this.search.info).then((res) => {
        this.infomations = {
          title: res.data.title ? res.data.title.MESSAGE : '',
          body: res.data.body,
        }
        this.async.info = false
      })
    },
    // アクティベート済ステータスか判定
    isCheckActivated(status) {
      return (
        status === Constant.USER.STATUS.ACTIVATED ||
        status === Constant.USER.STATUS.CHANGEID
      )
    },
    // 仕様不可ステータスか判定
    isCheckRestrict(status) {
      return status === Constant.USER.STATUS.RESTRICT
    },
    // 代理ログイン
    async dairiLogin(user) {
      this.spinerOn()
      const admin = {
        ROLE: Constant.USER.ROLE.ADMIN_MEMBER,
        ADMIN_USER_ID: Store.state.user.data.USER_ID,
        ADMIN_TANTO_ID: Store.state.user.data.ID,
      }
      await this.getAccountPW(user.TANTO_ID)
        .then((res) => {
          user.PASSWORD = res.data.pw
        })
        .catch((err) => {
          this.scroll('clear')
          this.spinerOff()
          this._alert(err.message, false)
        })
      await Store.dispatch('auth/destroy').catch((err) => {
        this.scroll('clear')
        this.spinerOff()
        this._alert('代理ログインに失敗しました', false)
        this.$router.push({ name: 'Login' })
      })
      await this.proxyLogin(user)
        .then((res) => {
          Store.commit('user/update', admin)
          this.$router.push({ name: 'Home' })
        })
        .catch((err) => {
          this.scroll('clear')
          this.spinerOff()
          this._alert('代理ログインに失敗しました', false)
        })
    },
  },
  computed: {
    // モーダル表示中ユーザが非アクティベートユーザが判定
    isInitialAccount() {
      return this.mdlAccount.STATUS === Constant.USER.STATUS.INITIAL
    },
    // 入力エラー判定
    isError() {
      return (
        this.$v.mdlAccount.$invalid || this.isEmailError || !this.isEmailChecked
      )
    },
    isGroupTorihiki() {
      let result = false
      for (let i = 1; i <= GROUP_TORIHIKI_MAX; i++) {
        if (this.group[`JYUCYU_SHIKI_CD${i}`]) {
          result = true
          break
        }
      }
      return result
    },
    groupTitle() {
      let title = 'グループ管理'
      switch (this.groupMode) {
        case 'add':
        case 'add_torihiki':
          title = 'グループ作成'
          break
        case 'edit':
        case 'edit_torihiki':
          title = 'グループ編集'
          break
      }
      return title
    },
  },
  created() {
    this.setGroupList()
    this.setAccount()
    this.setCompany()
    this.setInfo()
  },
}
</script>

<style lang="sass">
ul.suggestions
  max-height: 250px
  overflow-y: scroll
</style>
<style lang="sass" scoped>
@import '../../assets/css/logico2'
.suggestions
  height: 250px
  overflow-y: scroll
.eye-icon
  width: 24px
  height: 24px

#group-dialog
  label
    width: 100% !important
    margin: 0

#account-dialog,
#info-dialog,
#group-edit-modal
  table
    margin: 0
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
      padding: 1.5%
    td
      width: 68%
      background: #fff
section#admin-company-list
  .list-btn
    font-weight: bold
    color: white
</style>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/Index.vue